import style from "../../../../assets/scss/common/modal/leaveModal.module.scss";
import {useModal} from "../../../../hooks/hooks";
import {LeaveStep} from "../LeaveModal";
import {LeaveReason, UserLeavePostDTO} from "../../../../types/user";
import {useCookies} from "react-cookie";
import {useLeaveMember} from "./hooks/useLeaveMember";
import {useTranslation} from "react-i18next";

interface Args{
    confirmStatus: string;
    isAllAgreementSelected: boolean;
    currentLeaveStep: LeaveStep;
    setCurrentLeaveStep: (_:LeaveStep) => void;
    radioOption: LeaveReason;
    radioTextReason: string;
    setErrorMessage: (_: string) => void;
}

export function LeaveButtonField(
    {confirmStatus, isAllAgreementSelected, currentLeaveStep, setCurrentLeaveStep,
        radioOption, radioTextReason, setErrorMessage}: Args){
    const { t } = useTranslation("userInfo");
    const {closeModal, openAlertModal, openConfirmModal} = useModal();
    const {leaveRequestMember} = useLeaveMember();
    const [, , removeCookie] = useCookies(['accessToken', 'refreshToken']);


    // 탈퇴 완료 요청할 수 있는 상태들
    const radioNoneStatus = radioOption !== LeaveReason.NONE;
    const radioEtcStatus = (radioOption === LeaveReason.ETC && radioTextReason !== '') || radioOption !== LeaveReason.ETC;

    const isHoverActiveStatus = (currentLeaveStep === LeaveStep.STEP1 && isAllAgreementSelected) || (radioNoneStatus && radioEtcStatus)

    const onClickStepChange = (currentStep: LeaveStep) => {
        if (currentStep === LeaveStep.STEP1) {
            if (isAllAgreementSelected) {
                setErrorMessage('')
                setCurrentLeaveStep(LeaveStep.STEP2);
            } else {
                setErrorMessage(t('leave.warning.step1'))
            }
        }

        if(currentStep === LeaveStep.STEP2){
            if (radioNoneStatus && radioEtcStatus) {
                handleLeave();
            } else if(!radioNoneStatus){
                setErrorMessage(t('leave.warning.step2'))
            }
        }

    }

    const handleLeave = () => {

        const leaveRequest: UserLeavePostDTO = {
            reason: radioOption === LeaveReason.ETC ? radioTextReason : radioOption
        }
        const confirmLeaveModal = () => {
            openConfirmModal(
                {
                    title: t("modal.leave.info"),
                    desc: `${t("modal.leave.ensure1")}\n${t("modal.leave.ensure2")}\n${t("modal.leave.ensure3")}`,
                },
                () => {
                    leaveRequestMember(leaveRequest).then(r => console.log(leaveRequest))
                    removeCookie('accessToken', { path: '/' });
                    removeCookie("refreshToken", {path: '/'})
                    closeModal();
                    openAlertModal(
                        {
                            title: t("modal.leave.info"),
                            desc: t("modal.leave.complete"),
                            callback: () => window.location.href = "/"
                        },
                    )
                }
            );
        }

        confirmLeaveModal()
    }
    return(
        <>
            <div className={style.leaveButtonWrapper}>
                <div className={style.buttonWrapper}>
                    <button className={style.cancelButton} onClick={closeModal}>
                        {t('btn.cancel')}
                    </button>
                    <button
                        className={`${style.confirmButton} ${isHoverActiveStatus ? style.selected :  ''}`}
                        onClick={() => onClickStepChange(currentLeaveStep)}>
                        {confirmStatus}
                    </button>
                </div>
            </div>
        </>
    )
}